<ng-container *transloco="let t">
  <mat-form-field appearance="outline" class="full-width">
    <mat-label>{{ label }}</mat-label>
    <input
      matInput
      [type]="type"
      [placeholder]="placeholder ?? ''"
      [value]="value"
      (input)="onInput($event.target.value)"
      (blur)="onTouched()"
      [disabled]="disabled"
      [errorStateMatcher]="errorStateMatcher"
    />
    <mat-error *ngIf="ngControl?.control?.hasError('required')">
      {{ t('This field is required') }}
    </mat-error>
  </mat-form-field>
</ng-container>
